<template>
  <div class="bg-white rounded-lg border border-gray-200 overflow-hidden flex flex-col" style="min-height: 36rem; height: calc(100vh - 220px);">
    <ArtifactDetail
      v-if="selectedId"
      :key="selectedId"
      :artifact="artifact"
      :record-id="selectedId"
      :context="context"
      @back="closeRecord"
      @saved="load"
    />
    <div v-else class="flex-1 min-h-0 p-4 flex flex-col">
      <p class="text-xs text-gray-600 mb-3 max-w-3xl">{{ artifact.help }}</p>
      <ArtifactList
        class="flex-1 min-h-0"
        :artifact="artifact"
        :rows="rows"
        :loading="loading"
        :error="error"
        :creating="builderVisible"
        @open="openRecord"
        @create="builderVisible = true"
      />
    </div>
    <DataAttributeBuilderModal
      :visible="builderVisible"
      @close="builderVisible = false"
      @created="onCreated"
    />
  </div>
</template>

<script>
import axios from 'axios';
import ArtifactList from '@/components/Admin/MetricStudio/core/ArtifactList.vue';
import ArtifactDetail from '@/components/Admin/MetricStudio/core/ArtifactDetail.vue';
import { getArtifact } from '@/components/Admin/MetricStudio/core/artifactRegistry';
import DataAttributeBuilderModal from './DataAttributeBuilderModal.vue';
import { dataAttributeLocation } from '../../../router/data_routes';

export default {
  name: 'OverviewEtlDataAttributes',
  components: { ArtifactList, ArtifactDetail, DataAttributeBuilderModal },
  data() {
    return {
      artifact: getArtifact('attribute'),
      rows: [],
      loading: false,
      error: null,
      builderVisible: false,
    };
  },
  computed: {
    // The open record lives in the path: /data/data-attributes/:id.
    selectedId() {
      if (this.$route.name !== 'DataAttribute') return null;
      const id = Number(this.$route.params.id);
      return Number.isFinite(id) && id > 0 ? id : null;
    },
    context() {
      return { attributes: this.rows };
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.error = null;
      try {
        const { data } = await axios.get(this.artifact.listUrl);
        this.rows = Array.isArray(data) ? data : (data.results || []);
      } catch (e) {
        this.error = `Failed to load data attributes: ${e?.response?.data?.detail || e.message}`;
      } finally {
        this.loading = false;
      }
    },
    openRecord(row) {
      this.$router.push(dataAttributeLocation(row.id));
    },
    closeRecord() {
      this.$router.push(dataAttributeLocation(null));
    },
    async onCreated(da) {
      this.builderVisible = false;
      await this.load();
      if (da && da.id) this.openRecord(da);
    },
  },
};
</script>
